export const recoverPassword = (payload: { login: string }) => ({
    type: "@saga/RECOVER_PASSWORD",
    payload
});
